import { render, staticRenderFns } from "./TravelCostList.vue?vue&type=template&id=22b4a320&scoped=true&"
import script from "./TravelCostList.vue?vue&type=script&lang=js&"
export * from "./TravelCostList.vue?vue&type=script&lang=js&"
import style0 from "./TravelCostList.vue?vue&type=style&index=0&id=22b4a320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4a320",
  null
  
)

export default component.exports